/**
 * LandingCTA - Call to Action section
 */
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight, Check } from 'lucide-react';
import { useTranslation } from '../../i18n';

const LandingCTA = () => {
  const { t } = useTranslation();
  
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="relative overflow-hidden rounded-3xl bg-emerald-950 p-8 md:p-12">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg width=%2260%22 height=%2260%22 viewBox=%220 0 60 60%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cg fill=%22none%22 fill-rule=%22evenodd%22%3E%3Cg fill=%22%2334d399%22 fill-opacity=%220.05%22%3E%3Cpath d=%22M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z%22/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')] opacity-50" />
          <div className="relative text-center">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4">
              {t('landing.readyToGoGlobal')}
            </h2>
            <p className="text-emerald-200 text-lg mb-8 max-w-lg mx-auto">
              {t('landing.joinThousands')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/register">
                <Button size="lg" className="rounded-full px-8 py-6 bg-white text-emerald-950 hover:bg-emerald-50 text-lg" data-testid="cta-get-started-btn">
                  {t('landing.createFreeAccount')}
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Button>
              </Link>
            </div>
            <div className="mt-8 flex flex-wrap justify-center gap-6 text-emerald-200 text-sm">
              <span className="flex items-center gap-2">
                <Check className="w-4 h-4" /> {t('landing.noMonthlyFees')}
              </span>
              <span className="flex items-center gap-2">
                <Check className="w-4 h-4" /> {t('landing.freeVirtualCards')}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingCTA;
